import { render, staticRenderFns } from "./globalSetting.vue?vue&type=template&id=45bfd1b5&"
import script from "./globalSetting.vue?vue&type=script&lang=js&"
export * from "./globalSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports